export default class CurrencyHelper {
	static formatCurrency (number, symbol = null) {
		if (number) {
			let formatedNumber = number.toString()
			formatedNumber = formatedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

			if (symbol) {
				return formatedNumber + ' ' + symbol
			}

			return formatedNumber
		}

		return '0'
	}
}



// WEBPACK FOOTER //
// ./src/common/utils/currency-helper.js